import { httpCreate } from './http';

const http = httpCreate('/srv/authorize');

export const authorize = {
	// pageNum, pageSize
	getAuthorPage(params) {
		return http.get('', { params });
	},
	add(data) {
		return http.post('/agent/add', data);
	},
	// pageNum, pageSize, username
	getAuthorByUname(params) {
		return http.get('/getByParam', { params });
	},
	//pageNum, pageSize, userId
	getAuthorById(params) {
		return http.get('/getByUId', { params });
	},
	deleteAuthor(data) {
		return http.post('', data);
	},
	//pageNum, pageSize
	getOrderListInvoice(data, params) {
		return http.post('/getByUId', data, { params });
	},
	getWithTrx(data, params) {
		return http.post('/agent/getWithTrx', data, { params });
	},
	/**
	 * 新增自定义授权
	 * @param {*} formData
	 */
	addSelfAuthor(formData) {
		return http.post('/agent/add/self-defined', formData);
	},
	/**
	 * 获取自定义授权类型
	 * @param {number} photoLive 0：图文直播 1：照片直播
	 * @returns
	 */
	getSelfAuthorList(photoLive) {
		return http.get(`/self-defined/priceList?photoLive=${photoLive}`);
	},
};
